module.exports = __webpack_public_path__ + "static/media/09.5f9b35d1.jpg";